<template lang="pug">
  v-layout.box-vida-free-main
    v-flex.vida-free-mobile(v-if="($vuetify.breakpoint.width < 1024)" )
      VidaFreeMobile(
        :infoPoliza="infoPoliza"
        :infoUser="infoUser"
        :action="action"
      )
    v-flex.vida-free-desktop.border-radius-top(v-if="($vuetify.breakpoint.width >= 1024)" )
      VidaFreeDesktop(
        :infoPoliza="infoPoliza"
        :infoUser="infoUser"
        :action="action"
      )
    v-flex.box-guia-mis-seguros(v-if="($vuetify.breakpoint.width >= 1200)" )
      GuiaMisSeguros.box-guia-seguros-formatter(
        :producto="infoPoliza.nombreProducto"
      )

</template>

<script>
import VidaFreeDesktop from './VidaFreeDesktop.vue'
import VidaFreeMobile from './VidaFreeMobile.vue'
import GuiaMisSeguros from '../../components/mis-seguros/GuiaMisSeguros.vue'
export default {
  props: [
    'infoPoliza',
    'infoUser',
    'action'
  ],
  components: {
    VidaFreeDesktop,
    VidaFreeMobile,
    GuiaMisSeguros
  },
  mounted () {
    setTimeout(() => { window.hj('event', 'ev-zs-misseguros-vida-free') }, 3000)

    this.$store.dispatch('nps/updateEventLogNps', {
      datos: {
        numeroPoliza: this.infoPoliza.numeroPoliza,
        productoConsultado: this.infoPoliza.ramo,
        subproductoConsultado: this.infoPoliza.nombreProducto
      }
    })
  }

}
</script>

<style scoped>
@media screen and (min-width: 350px) {
  .box-vida-free-main .vida-free-mobile {
    background-color: #fff;
    padding: 0;
    margin: 0;
  }
}

@media screen and (min-width: 1024px) {

  .box-vida-free-main {
    height: calc(100vh - 61px) !important;
  }

  .box-vida-free-main .vida-free-desktop {
    margin: 5px 9px 0 5px;
    background-color: #ffffff;
    border-radius: 10px;
    padding: 15px 0 20px;
    height: -webkit-fill-available;
  }

  .box-guia-mis-seguros {
    background-color: #ffffff;
    max-width: 300px;
    width: 330px;
    padding: 40px 25px;
  }

}

@media (min-width: 1380px) {
  .box-guia-mis-seguros {
    max-width: 330px;
    padding: 40px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vida-free/VidaFree.vue